import Header from "./Header";
import Footer from "./Footer";
import StickyMobileBar from "./StickyMobileBar";

export default function PageShell({ children }) {
  return (
    <div className="min-h-screen bg-white text-[#0B2545]">
      <Header />
      <main className="pt-[72px] md:pt-[88px]">{children}</main>
      <Footer />
      <StickyMobileBar />
    </div>
  );
}
